import React, { useContext, useState } from 'react';
import './SignIn.css';
import config from '../../config';
import { inputOnlyNumbers, testPasswordValidator } from '../../utils/CommonUtilities';
import { AuthContext } from '../../contexts/authContext';
import { useNavigate } from 'react-router-dom';
import CircleProgress from '../../components/CircleProgress/CircleProgress';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { VisibilityIcon, VisibilityOffIcon, KeyIcon, AccountCircleIcon } from '../../assets/icons/icons';
import IGPLogoWhite from '../../assets/svgs/IGPDecauxWhite.svg';
import useNotification from '../../hooks/useNotification';
import { InputLabel } from '@mui/material';

function SignIn() {
	const auth = useContext(AuthContext);
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [signinLoading, setSigninLoading] = useState(false);
	const [openDialogMFA, setOpenDialogMFA] = useState(false);
	const [codeTOTP, setCodeTOTP] = useState('');
	const { notificationError } = useNotification();

	const signIn = async(event) => {
		event.preventDefault();
		setSigninLoading(true);
		try{
			let response = await auth.signInWithEmail(email, password);
			if(response === 'SOFTWARE_TOKEN_MFA'){
				setOpenDialogMFA(true);
				setSigninLoading(false);
			}else{
				//await auth.singInOnOtherApps(email, password);
				navigate(config.HOME_PAGE);
				setSigninLoading(false);
			}
		}catch(e){
			if(e instanceof Error){
				setSigninLoading(false);
				//notifica di credenziali errate diretta nel caso in cui l'mfa non sia obbligatorio
				notificationError('Credenziali Errate')
			}else{
				setSigninLoading(false);
				//altrimenti forzo lo stesso il popup anche da credenziali errate
				setOpenDialogMFA(true);
			}
		}
	}

	const btnEnabled = (email !== '' && password !== '');

	const handleCloseDialog = () => {
		setCodeTOTP('');
		setOpenDialogMFA(false);
	}

	const submitTOTP = async(event = false) => {
		if(event)event.preventDefault();
		setSigninLoading(true);
		handleCloseDialog();
		try{
			await auth.signInWithTOTP(codeTOTP, email, password);
			//await auth.singInOnOtherApps(email, password);
			setSigninLoading(false);
			navigate(config.HOME_PAGE);
		}catch(e){
			setSigninLoading(false);
			notificationError('Credenziali Errate');
		}
	}

	return (
		<div className='signin'>
			{signinLoading && (<CircleProgress isDialog={true}/>)}
			<div id="signin-form" className="signin-container">
				<div className="app-login-header">
					<a href="https://www.igpdecaux.it/it" target="_blank" rel="noreferrer">
						<img
							src         ={IGPLogoWhite}
							alt         ="IGPDecaux"
							draggable   ="false"
							className   ="igp-logo"
						/>
					</a>
				</div>
				<div className="user-psw-container">
					<form className='login-form' onSubmit={ (event) =>signIn(event) }>
						<div className='cred-section'>
							<FormControl className="signin-credentials-wrapper top">
								<InputLabel htmlFor="email">Email</InputLabel>
								<OutlinedInput
									name            ="email"
									id='email'
									label			="Email"
									value           ={ email }
									placeholder     ="Inserisci email"
									type			="text"
									spellCheck      ={ false }
									onChange        ={ e => { setEmail(e.target.value); } }
								/>
							</FormControl>
							<FormControl className="signin-credentials-wrapper">
								<InputLabel htmlFor="password">Password</InputLabel>
								<OutlinedInput
									name            ="password"
									id              ="password"
									label="Password"
									placeholder     ="Inserisci password"
									type            ={ showPassword ? 'text' : 'password' }
									value           ={ password }
									onChange        ={ e => { setPassword(e.target.value); } }
									spellCheck      ={ false }												
									error={!testPasswordValidator(password)}
									endAdornment    ={
										<InputAdornment position="end">
											<IconButton
												aria-label ="toggle password visibility"
												onClick    ={ e => { setShowPassword(!showPassword); } }
											>
												{ showPassword ? <VisibilityIcon/> : <VisibilityOffIcon/> }
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
						</div>
				
						<div className="button-wrapper">
							<Button
								variant     = "outlined"
								type='submit'
								className   ={ "text-uppercase signin-btn" }
								disabled    ={ !btnEnabled }
							>Accedi</Button>
							<div
								className   ={ "text-uppercase forgot-password-label" }
								onClick     ={ ()=>{navigate('/forgot-password')} }
							>Password Dimenticata?</div>
						</div>
					</form>
				</div>
				<div className="footer-info top-bottom-section"></div>
			</div>
			<Dialog open={openDialogMFA} onClose={handleCloseDialog}>
				<DialogTitle>Multi-Factor Authentication</DialogTitle>
				<DialogContent className='align-mfa-center'>
					<DialogContentText className='font-12'>
						Inserisci un codice MFA dalla tua applicazione authenticator per completare il login
					</DialogContentText>
					<form onSubmit={(event) =>submitTOTP(event)}>
						<FormControl className="signin-credentials-wrapper">
							<OutlinedInput
								className       ="center-text font-24"
								autoComplete='off'
								name            ="totp"
								id              ="totp"
								placeholder     ="Codice"
								type            ='text'
								inputProps		={{maxLength: 6}}
								value           ={ codeTOTP }
								onChange        ={ e => { if(inputOnlyNumbers(e.target.value))setCodeTOTP(e.target.value); } }
								spellCheck      ={ false }
								autoFocus
							/>
						</FormControl>
					</form>
				</DialogContent>
				<DialogActions className='flex-box-between'>
					<Button onClick={handleCloseDialog}>Annulla</Button>
					<Button onClick={submitTOTP} variant='contained'>Conferma</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default SignIn;